// Dependencias
import Vue from 'vue';
import vueAxios from 'vue-axios';
import App from './App';
import router from './router';
import './router/permission';
import store from './store';
import './plugins/element';
import 'normalize.css/normalize.css';
import http from './api';
import ErrorNotify from './utils/ErrorNotify';
import currencyFormater from './utils/currencyFormater';
import numberFormater from './utils/numberFormater';
import goBack from './utils/goBack';

const isWebViewHandler = () => store.state.app.isWebView;

Vue.use(vueAxios, http);
Vue.prototype.$ErrorNotify = ErrorNotify;
Vue.prototype.$currencyFormater = currencyFormater;
Vue.prototype.$numberFormater = numberFormater;
Vue.prototype.$goBack = goBack;
Vue.prototype.$isWebView = isWebViewHandler;

Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.config.devtools = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
